<template>
  <div class="vb-confirm">
    <h1 class="vb-confirm__title">Complimenti!</h1>
    <p class="vb-confirm__subtitle">La tua prenotazione è confermata.</p>
    <button type="button" class="vb-confirm__print mb-2" @click="window.print()">
      <vb-icon :name="'print'" :size="16" :color="sass('info')" />
      <span>Stampa la conferma</span>
    </button>
    <p class="vb-confirm__text mb-3">
      Trovi di seguito un <strong>promemoria della tua prenotazione</strong> che
      puoi salvare o stampare. Ti abbiamo inviato lo stesso promemoria anche
      all'indirizzo <strong>{{ email }}</strong
      >.<br />
      Alcuni giorni prima della partenza, all'indirizzo {{ email }} ti invieremo
      la <strong>documentazione ufficiale di viaggio</strong>.
    </p>
    <p class="vb-confirm__text mb-4">
      Per qualsiasi informazione aggiuntiva non esitare a contattarci ai
      contatti che trovi alla fine di questa pagina. Ricordati di avere a
      disposizione il <strong>Numero di prenotazione</strong> e il
      <strong>Booking ID VadoBay</strong>
      che trovi in questa pagina e che ti abbiamo inviato anche per email.
    </p>

    <b-row class="vb-confirm__wrap">
      <b-col md="12" lg="8" xl="9">
        <pratica
          :services="services"
          :passengers="passengers"
          :statics_fallback="false"
          title_tag="h2"
        >
          <template #details-subtitle>
            <template v-if="has_flights">Ecco i dettagli del tuo pacchetto viaggio.</template>
            <template v-else>Ecco i dettagli del tuo soggiorno.</template>
          </template>
        </pratica>
      </b-col>
      <b-col md="12" lg="4" xl="3">
        <div class="vb-confirm__sidebar sticky-top">
          <h3 class="vb-heading h5 mb-4">Riferimenti della prenotazione</h3>

          <div v-if="external_confirm_code" class="vb-confirm__sidebar-item">
            <strong>Numero prenotazione (pratica):</strong>
            <span>{{ external_confirm_code }}</span>
          </div>

          <div class="vb-confirm__sidebar-item">
            <strong>Codice di conferma VadoBay:</strong>
            <span>{{ internal_confirm_code }}</span>
          </div>

          <div class="vb-confirm__sidebar-item">
            <strong>Prezzo:</strong>
            <span>{{ live_price }}€</span>
          </div>
        </div>
      </b-col>
    </b-row>
    <my-alpitour class="section" />
  </div>
</template>

<script>
import { has_flights } from "@alpitour/utilities";
import Pratica from "@alpitour/components/blocks/pratica.vue";
import MyAlpitour from "@alpitour/components/blocks/my-alpitour";
export default {
  name: "confirm-block",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  components: {
    pratica: Pratica,
    "my-alpitour": MyAlpitour,
  },
  computed: {
    voucher_data() {
      return this.data.holidayVoucher || this.data
    },
    external_confirm_code() {
      const {
        order_id,
        numPratica
      } = this.voucher_data
      return order_id || numPratica
    },
    internal_confirm_code() {
      return this.voucher_data.confirmcode
    },
    live_price() {
      return this.voucher_data.live_price
    },
    email() {
      return this.voucher_data.email || ''
    },
    services() {
      if (this.data.orderData) {
        return this.data.orderData.services;
      }

      return {
        hotels: [this.data],
      };
    },
    has_flights() {
      return has_flights(this.services);
    },
    passengers() {
      const { passengers = [], orderData } = this.data || {};
      if (passengers.length) {
        return passengers;
      }
      if (orderData) {
        const { passenger = [] } = orderData.compositions || {};
        if (passenger.length) {
          return passenger;
        }
      }
      return [];
    },
  },
};
</script>

<style lang="scss">
.vb-confirm {
  &__title {
    color: var(--primary);
    font-size: $h2-font-size;
    margin-bottom: 0;

    @include media-breakpoint-up(lg) {
      font-size: $h1-font-size;
    }
  }

  &__subtitle {
    color: var(--primary);
    font-size: $font-size-lg;
    font-weight: $vb-font-weight-semibold;
    margin-bottom: $grid-gutter-width/2;

    @include media-breakpoint-up(lg) {
      font-size: $font-size-xl;
    }
  }

  &__print {
    display: none;
    padding: 0;
    border: 0;
    background-color: transparent;
    font-size: $font-size-base;
    font-weight: $vb-font-weight-semibold;
    color: $info;

    @include media-breakpoint-up(xl) {
      display: inline-flex;
      align-items: center;
    }

    span {
      text-decoration: underline;
    }

    .vb-icon {
      margin-right: $grid-gutter-width/6;
    }
  }

  &__text {
    font-size: $font-size-md;
  }

  &__sidebar {
    background-color: $white;
    padding: $grid-gutter-width/2;
    border-radius: $border-radius;
    top: $grid-gutter-width/2;
    margin-top: $grid-gutter-width;

    @include media-breakpoint-up(lg) {
      margin-top: 0;
    }

    &-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: $grid-gutter-width/3;

      span {
        font-size: $font-size-lg;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  @media print {
    &__wrap {
      // inverto l'ordine del blocco "Riferimenti prenotazione"
      & > div:first-child {
        order: 2;
      }
    }

    &__sidebar {
      margin-top: $grid-gutter-width/2;
      margin-bottom: $grid-gutter-width/2;
    }

    .accordion-block__body {
      display: block !important;
      height: auto !important;
      visibility: visible !important;
    }

    @at-root .site-footer,
      .site-header__navigation,
      .site-header__user {
      display: none !important;
    }

    @at-root .site-header__logo {
      margin: 0 auto;
    }
  }
}
</style>
